"use strict";

exports.__esModule = true;
exports.ListDetailsLayoutIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ListDetailsLayoutIcon = exports.ListDetailsLayoutIcon = function ListDetailsLayoutIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: props.height,
    viewBox: "0 0 32 32",
    width: props.width
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.42 7.221c0-.951-.771-1.721-1.721-1.721h-6.97c-.951 0-1.721.771-1.721 1.721v6.103c0 .951.771 1.721 1.721 1.721H13.7c.951 0 1.721-.771 1.721-1.721V7.221zM15.42 18.676c0-.951-.771-1.721-1.721-1.721h-6.97a1.72 1.72 0 0 0-1.721 1.721v6.104c0 .95.771 1.721 1.721 1.721H13.7c.951 0 1.721-.771 1.721-1.721v-6.104z",
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.394 -5.086)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.394 -2.803)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.394 -.537)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.36 1.798)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.29 -16.476)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.29 -14.193)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.29 -11.927)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 20.291,
    y: 22.481,
    width: 11.914,
    height: 1.408,
    transform: "matrix(.99999 .0044 0 1.00001 -3.256 -9.593)",
    rx: 0.327,
    ry: 0.327,
    fill: "#515151"
  }));
};